/****************************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigSummary.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date          : 03 Nov 2020
 *
 * @Version      : Version 1.0
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3824 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
 ****************************************************************************************/
import * as React from 'react';
import {Card, Icon, Grid, Notification} from '@scuf/common';
import { DataTable} from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import './ConfigureProduct.css';
import '@scuf/datatable/honeywell/theme.css';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

function unitPriceDisplay( cellData: ICellData) {
    return <span>${parseFloat(cellData.value).toFixed(2)}</span>;
  }

function rowExpansionTemplate(data){
       return <Notification hasIcon={true}  severity="important"   title="License key already purchased" style={{margin: 0}} >{data.notes}</Notification>;
  }



export function ConfigSummary(props: any){
const notesRowData = props.productFeatures.filter((product: any) => {
        if (typeof product.notes !== 'undefined' ){
            return product;
        }
        });
return(
  <React.Fragment>
    <Card className="fullwidthCard">
            <Card.Content>
                <Grid>
                    <Grid.Row>
                    <Grid.Column width={11} className="fullwidthRow">
                            <span className="cp-serial-title-text"> CONFIGURED FEATURES</span>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div className="cp-conf-edit"><Icon root="common" name="edit" size="small"
                                                            onClick={props.gotoConfigureFeaturesTab}/></div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12} className=" fullwidthRow">
                          <DataTable
                            data={props.productFeatures}
                            expandedRows={ notesRowData }
                            scrollable={true}
                            scrollHeight="150px"
                            virtualRowHeight={48}
                            rowExpansionTemplate={(data) => rowExpansionTemplate(data)}
                            resizableColumns={true}
                          >

                            <DataTable.Column field="partNumber" header="Part Number- Feature Name"  align="left" />
                            <DataTable.Column field="validity" header="Validity" align="left" />
                            <DataTable.Column field="unitPrice" header="Unit Price"  renderer={unitPriceDisplay}  align="left"/>
                          </DataTable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
        </Card.Content>
        </Card>
                        </React.Fragment>
);
}
